import "../../style/pages/Team.scss";

const team = [
  {
    name: "Piet",
    title: "Directeur",
    imgUrl: "/asset/team/piet.webp",
  },
  {
    name: "Pravish",
    title: "Systeem- en netwerkbeheerder",
    imgUrl: "/asset/team/pravish.webp",
  },
  {
    name: "Roel",
    title: "Systeem- en netwerkbeheerder",
    imgUrl: "/asset/team/roel.webp",
  },
  {
    name: "Marjon",
    title: "Administratie en HR",
    imgUrl: "/asset/team/marjon.webp",
  },
  {
    name: "Robin",
    title: "Office manager en telefonie",
    imgUrl: "/asset/team/robin.webp",
  },
  {
    name: "Thomas",
    title: "Junior systeembeheerder",
    imgUrl: "/asset/team/thomas.webp",
  },
  {
    name: "Lux",
    title: "Ontspanningsmanager",
    imgUrl: "/asset/team/lux.webp",
  },
  {
    name: "Nick",
    title: "Software engineer",
    imgUrl: "/asset/team/nick.webp",
  },
];

export default function Team() {
  return (
    <div className="team-page">
      <title>Team - Topassist</title>
      <meta
        name="description"
        content="Het team dat u versterkt wanneer u dat ook maar nodig heeft!"
      />
      <div className="team">
        {team.map((member) => (
          <div className="member" key={member.name}>
            <img
              className={member.contrastyImg ? "contrasty" : ""}
              src={member.imgUrl}
              alt="Employee"
              loading="lazy"
            />
            <div className="details">
              <h1>{member.name}</h1>
              <h2>{member.title}</h2>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
